export default "__VITE_ASSET__BSnKQy4z__";